<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
          <template #menu="{ row }">
            <el-button
              type="text"
              icon="el-icon-position"
              v-if="permissionList.loginBtn"
              @click="openLoginForm(row)"> 登录
            </el-button>
          </template>
        </avue-crud>

      <!--  登录输入框  -->
      <el-dialog
        title="登录"
        width="50%"
        v-if="loginDialogShow"
        :visible.sync="loginDialogShow"
        :append-to-body="true"
        :modal-append-to-body="true"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <el-form :model="loginForm" label-position="left">
          <el-form-item label="账号：" :label-width="formLabelWidth1">
            <el-input v-model="loginForm.userName"></el-input>
          </el-form-item>
          <el-form-item label="密码：" :label-width="formLabelWidth1">
            <el-input v-model="loginForm.password" show-password></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="loginFirstLoading" @click="loginOperate">确 定</el-button>
          <el-button @click="closeLoginForm" :loading="loginFirstLoading">取 消</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="短信验证码"
        width="60%"
        v-if="showSmsCode"
        :visible.sync="showSmsCode"
        :append-to-body="true"
        :modal-append-to-body="true"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <el-form :model="smsForm" label-position="left">
          <el-form-item label="验证码" :label-width="formLabelWidth2">
            <el-input v-model="smsForm.smsCode"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="loginSmsLoading" @click="loginSmsCode">确 定</el-button>
          <el-button @click="closeLoginSmsCode" :loading="loginSmsLoading">取 消</el-button>
        </div>
      </el-dialog>

      <el-dialog title="提示" width="40%"
                 v-model="tipShow"
                 :append-to-body="true"
                 :modal-append-to-body="true"
                 :close-on-click-modal="false"
                 :destroy-on-close="true">
        <div class="plate-change-tip">
          <div class="t1">
            <span >登录失败！失败原因：{{errorMsg}}</span>
            <br/>
            <span >请解决问题后，重新登录！</span>
          </div>
        </div>
        <template #footer>
          <div>
            <el-button @click="tipShow = false">确 定</el-button>
          </div>
        </template>
      </el-dialog>

      <!--  扫码认证二维码  -->
      <el-dialog title="扫码认证二维码" width="30%"
                 v-if="qrCodeShow"
                 :visible.sync="qrCodeShow"
                 :append-to-body="true"
                 :modal-append-to-body="true"
                 :close-on-click-modal="false"
                 :destroy-on-close="true">
        <div class="qrcode-container">
          <div style="text-align: center">
            <qrcode-vue :value="qrCodeData" :options="qrcodeOptions" />
          </div>
          <el-form :model="qrCodeConfirmForm" label-position="right">
          </el-form>
        </div>
        <template #footer>
          <div>
            <el-button type="primary" :loading="loginQrCodeConfirmLoading" @click="submitBlueConfirm">确 定</el-button>
            <el-button :loading="loginQrCodeConfirmLoading" @click="closeBlueConfirm">取 消</el-button>
          </div>
        </template>
      </el-dialog>
    </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  selectInterface,
  loginFirst,
  loginSecond,
  confirmBlueAuth,
} from '@/api/v4ward/digitaltickets/invoiceType';
    import {mapGetters} from "vuex";
import QrcodeVue from 'qrcode.vue';

    export default {
      components: {
        QrcodeVue // 注册组件
      },
        data() {
            return {
              loginFirstLoading: false,
              loginSmsLoading: false,
              loginQrCodeConfirmLoading: false,
              qrCodeConfirmForm:{
                id:'',
                authCode:'',
              },
              loginDialogShow: false,
              loginForm:{
                id:'',
                userName:'',
                password:'',
              },
              qrcodeOptions: {
                width: 400,
                height: 400,
                margin: 1,
                color: {
                  dark: '#000000',
                  light: '#ffffff',
                },
              },
              qrCodeShow: false,
              qrCodeData: '',
              tipShow: false,
              formLabelWidth1: '60px',
              formLabelWidth2: '90px',
              smsForm: {
                id:'',
                smsCode:''
              },
              blueConfirmForm: {
                id:'',
                taxIdentityCode:'',
              },
              errorMsg:'',
              showSmsCode: false,
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    labelWidth: 150,
                    searchShow: true,
                    searchMenuSpan:18,
                    // searchMenuPosition: "right",
                    //menuWidth: 250,
                    searchLabelWidth: 100,
                    border: true,
                    index: false,
                    viewBtn: false,
                    addBtn : false,
                    delBtn:false,
                    selection: false,
                    dialogClickModal: false,
                    column: [
                                                                                    {
                                    label: "id",
                                    prop: "id",
                                    editDisplay: false,
                                    addDisplay: false,
                                    viewDisplay: false,
                                    hide: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入id",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "发票类型编号",
                                    prop: "code",
                                    maxlength: 100,
                                    editDisabled: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入发票类型编号",
                                        trigger: "change"
                                    }],
                                  hide:true,
                                },
                                 {
                                    label: "发票类型名称",
                                    prop: "name",
                                    search: true,
                                    editDisabled: true,
                                    rules: [{
                                        required: true,
                                        message: "请输入发票类型名称",
                                        trigger: "change"
                                    }]
                                }, {
                                    label: "是否默认",
                                    prop: "isDefault",
                                    type: 'switch',
                                    dicData: [
                                        { label: '否', value: 0 },
                                        { label: '是', value: 1 },
                                    ],
                                    addDisplay: true,
                                    editDisplay: true,
                                    rules: [{
                                        required: true,
                                        message: "请选择是否默认",
                                        trigger: "change"
                                    }]
                                },
                      {
                        label: '接口类型',
                        width: 100,
                        prop: 'interfaceType',
                        type:"select",
                        dicUrl: "/api/v4ward/feeInvoiceInterface/selectFeeInvoceInterfacList",
                        props: {
                          label: "interfaceName",
                          value: "interfaceName",
                        },
                        rules: [
                          {
                            required: true,
                            message: '请选择接口类型',
                            trigger: 'change',
                          },
                        ],
                      },
                      {
                        label: '状态',
                        prop: 'status',
                        type: 'switch',
                        dicData: [
                          { label: '禁用', value: 0 },
                          { label: '启用', value: 1 },
                        ],
                        addDisplay: true,
                        editDisplay: true,
                        rules: [
                          {
                            required: false,
                            message: '请选择状态',
                            trigger: 'change',
                          },
                        ],
                      },

                      {
                        label: '微信开票默认类型',
                        prop: 'isWechatDefault',
                        width: 200,
                        type: 'switch',
                        dicData: [
                          { label: '否', value: 0 },
                          { label: '是', value: 1 },
                        ],
                        addDisplay: true,
                        editDisplay: true,
                        rules: [
                          {
                            required: false,
                            message: '微信开票默认类型',
                            trigger: 'change',
                          },
                        ],
                      },
                      {
                        label: '需要短信验证',
                        prop: 'needSmsCode',
                        width: 200,
                        type: 'switch',
                        dicData: [
                          { label: '否', value: "0" },
                          { label: '是', value: "1" },
                        ],
                        addDisplay: true,
                        editDisplay: true,
                        rules: [
                          {
                            required: false,
                            message: '需要短信验证',
                            trigger: 'change',
                          },
                        ],
                      },
                      {
                        label: '登录状态',
                        prop: 'loginStatus',
                        width: 200,
                        type: 'switch',
                        dicData: [
                          { label: '否', value: "0" },
                          { label: '是', value: "1" },
                        ],
                        display: false,
                      },
                      {
                        label: "接口参数",
                        prop: "interfaceParams",
                        type: "textarea",
                        maxlength: '200',
                        span:24,
                        showWordLimit: true,
                        addDisplay: true,
                        editDisplay: true,
                        hide: true,
                        rules: [{
                          required: false,
                          message: "请输入接口参数",
                          trigger: "change"
                        }]
                      },
                    ]
                },
                data: []
            };
        },
      mounted(){
        this.adjustView();
      },
      activated() {
        // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
        this.$nextTick(() => {
          this.$refs.crud.refreshTable();
        });
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    editBtn: this.vaildData(this.permission.invoicetype_edit, false),
                  loginBtn: this.vaildData(this.permission.invoicetype_login, false),
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
      watch:{
         'form.interfaceType'(val,oldval) {
           if(!oldval){
             return;
           }
           selectInterface({interfaceName:val|| ''}).then((data) => {
             this.form.interfaceParams = data.data[0].interfaceParams;
        });
       },
      },
        methods: {
          //打开登录弹框
          openLoginForm(row){
            //初始化数据
            this.loginForm.id = row.id;
            this.loginForm.userName = '';
            this.loginForm.password = '';
            this.loginDialogShow = true;
          },
          //关闭登录弹框
          closeLoginForm(){
            this.loginForm.id = '';
            this.loginDialogShow = false;
          },
          //登录-第一步
          loginOperate(){
            this.loginFirstLoading = true;
            //初始化
            this.smsForm.id = '';
            this.smsForm.smsCode = '';
            this.errorMsg = '';
            loginFirst(this.loginForm).then((res) => {
              this.loginFirstLoading = false;
              //需要短信认证和需要展示二维码啊，在这里不会同时为true
              let data = res.data;
              if(data.needSendSmsCode){
                this.smsForm.id = this.loginForm.id;
                this.closeLoginForm();
                this.$nextTick(() => {
                  this.showSmsCode = true;
                })
              }
              if(data.errorMsg){
                this.errorMsg = data.errorMsg;
                this.tipShow = true;
              }
              if(data.needQrCodeAuth){
                this.closeLoginForm();
                this.$nextTick(() => {
                  //二维码认证弹框
                  this.qrCodeShow = true;
                  this.qrCodeData = data.qrCodeData;
                })
              }
            }, error => {
              this.loginFirstLoading = false;
              window.console.log(error);
              loading();
            });
          },
          //登录-第二步（输入短信验证码）
          loginSmsCode(){
            this.loginSmsLoading = true;
            //二维码认证弹框
            this.qrCodeData = '';
            loginSecond(this.smsForm).then((res) => {
              this.loginSmsLoading = false;
              let data = res.data;
              if(data.needQrCodeAuth){
                this.qrCodeConfirmForm.id = this.smsForm.id;
                this.closeLoginSmsCode();
                this.$nextTick(() => {
                  //二维码认证弹框
                  this.qrCodeShow = true;
                  this.qrCodeData = data.qrCodeData;
                  this.qrCodeConfirmForm.authCode = data.authCode;
                })
              }
              if(data.errorMsg){
                this.errorMsg = data.errorMsg;
                this.tipShow = true;
              }
            }, error => {
              this.loginSmsLoading = false;
              window.console.log(error);
              loading();
            });
          },
          closeLoginSmsCode(){
            //关闭验证码输入框
            this.smsForm.id = '';
            this.showSmsCode = false;
          },
          //确认蓝票二维码认证
          submitBlueConfirm(){
            this.loginQrCodeConfirmLoading = true;
            confirmBlueAuth(this.qrCodeConfirmForm).then((res) => {
              this.loginQrCodeConfirmLoading = false;
              let data = res.data;
              if(data.errorMsg){
                this.errorMsg = data.errorMsg;
                this.tipShow = true;
              }
              if(data.loginSuccess){
                //二维码认证弹框
                this.$message.success('登录成功!');
                this.closeBlueConfirm();
                this.onLoad();
              }
            }, error => {
              this.loginQrCodeConfirmLoading = false;
              window.console.log(error);
              loading();
            });
          },
          closeBlueConfirm(){
            this.qrCodeShow = false;
            this.qrCodeData = '';
            this.qrCodeConfirmForm.authCode = '';
          },
          adjustView() {
            // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
            setTimeout(() => {
              window.onresize = () => {
                this.$nextTick(() => {
                  this.$refs.crud.refreshTable();
                });
              };
            });
          },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },

            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>

.dialog-footer {
  text-align: right;
  margin-bottom: 20px;
}
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
